<template>
  <div id="howtouse">
    <div class="inner">
      <div class="top">
        <div class="top_box">
          <div class="top_title">{{ $t("home_howtouse_title") }}</div>
          <div class="top_list">
            <div
              class="top_list_item"
              v-for="(item, index) of topLists"
              :key="index"
            >
              <div class="top_list_item_bg">
                {{ index + 1 < 10 ? "0" + (index + 1) : index + 1 }}
              </div>
              <div class="top_list_item_content">
                <div class="top_list_item_icon">
                  <div class="top_list_item_title">
                    {{ item.title }}
                  </div>
                  <div class="top_list_item_desc">
                    {{ item.desc }}
                  </div>
                </div>
                <div class="top_list_item_img">
                  <el-image :src="item.img"></el-image>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getCountryByDomain } from "@/common/config";
export default {
  name: "HowtouseView",
  data() {
    return {
      topList: [],
    };
  },
  computed: {
    country() {
      return getCountryByDomain(window.location.hostname);
    },
    topLists() {
      return this.topList.map((item) => {
        return {
          img: item.img,
          title: this.$t(item.title),
          desc: this.$t(item.desc),
        };
      });
    },
  },
  created() {
    // 根据 country 设置不同图片
    if (this.country === "hongkong") {
      this.topList = [
        {
          img: require("@/assets/Keeta2/香港图1@2x.png"),
          title: "home_howtouse_rent_title",
          desc: "home_howtouse_rent_desc_hk",
        },
        {
          img: require("@/assets/Keeta2/香港图2@2x.png"),
          title: "home_howtouse_charge_title",
          desc: "home_howtouse_charge_desc",
        },
        {
          img: require("@/assets/Keeta2/香港图3@2x.png"),
          title: "home_howtouse_return_title",
          desc: "home_howtouse_return_desc",
        },
      ];
    } else {
      this.topList = [
        {
          img: require("@/assets/Keeta2/使用步骤1@2x.png"),
          title: "home_howtouse_rent_title",
          desc: "home_howtouse_rent_desc",
        },
        {
          img: require("@/assets/Keeta2/使用步骤2@2x.png"),
          title: "home_howtouse_charge_title",
          desc: "home_howtouse_charge_desc",
        },
        {
          img: require("@/assets/Keeta2/使用步骤3@2x.png"),
          title: "home_howtouse_return_title",
          desc: "home_howtouse_return_desc",
        },
      ];
    }
  },
};
</script>
<style scoped lang="scss">
@import "@/styles/_variables.scss";
#howtouse {
  min-width: $min-width;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 80px 0 120px 0;
  background-color: #f7f8f9;
  .inner {
    width: 1200px;
  }

  .top {
    display: flex;
    flex-direction: column;
    align-items: center;
    .top_box {
      width: 100%;
      min-width: 431px;
      .top_title {
        color: #000000;
        font-weight: 900;
        font-size: 1.3rem;
        margin-top: -32px;
        font-family: $title-font;
      }
    }

    &_list {
      margin-top: 145px;
      display: flex;
      justify-content: space-between;
      gap: 22.5px;

      &_item {
        display: flex;
        position: relative;

        &_content {
          position: relative;
          z-index: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          background: rgba(255, 255, 255, 0.8);
          border-radius: 20px 80px 20px 20px;
          padding: 0px 19.5px 0px 19.5px;
        }

        &_bg {
          position: absolute;
          left: 50%;
          top: -60px;
          transform: translateX(-50%);
          font-size: 2.8rem;
          font-weight: 900;
          opacity: 0.7;
          line-height: 1;
          font-family: $content-font;
          background: linear-gradient(132deg, #ffe74d 1%, #ffdd00 100%);
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }
        &_icon {
          width: 100%;
          font-family: $content-font;
        }
        &_img {
          margin-top: 20px;
        }
        &_title {
          font-weight: 700;
          font-size: $font-size-small;
          margin: 30px 0 8px 0px;
        }
        &_desc {
          font-weight: 400;
          font-size: $font-size-mini;
          line-height: 28px;
          color: #999999;
        }
      }
    }
  }
}
</style>
